import React from "react";
import PropTypes from "prop-types";

import DialogForm from "ui/Dialog";

import useDialogMutation from "hooks/useDialogMutation";

const DialogFormWithMutation = (props) => {
  const {
    mutationQueries,
    refetchQueries = [],
    mutationOptions = {},
    fieldsWithPlaceForError = [],
    dataMapper,
    onClose,
  } = props;
  const { handleSubmit, loading } = useDialogMutation(
    mutationQueries,
    onClose,
    { dataMapper, refetchQueries, fieldsWithPlaceForError, ...mutationOptions },
  );

  return <DialogForm onSubmit={handleSubmit} isLoading={loading} {...props} />;
};

DialogFormWithMutation.propTypes = {
  mutationQueries: PropTypes.object.isRequired,
  refetchQueries: PropTypes.arrayOf(PropTypes.any),
  mutationOptions: PropTypes.object,
  dataMapper: PropTypes.func,
  initialValues: PropTypes.object.isRequired,
  validationSchema: PropTypes.object,
  fieldsWithPlaceForError: PropTypes.arrayOf(PropTypes.string),
  variant: PropTypes.oneOf(["primary", "error"]),
  Icon: PropTypes.elementType,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  submitButtonName: PropTypes.string,
  closeButtonName: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  disableSubmit: PropTypes.bool,
  preLoading: PropTypes.bool,
  preLoadingHeight: PropTypes.string,
};

export default DialogFormWithMutation;
